<template>
  <CCard>
    <CCardHeader>
      <h5>{{ title }}</h5>
      <h3>{{ selectedDirectory.empresa }}</h3>
      <span>{{ selectedDirectory.identificacion }}</span>
    </CCardHeader>
    <CCardBody>
      <CTabs>
            <CTab title="Estado de cuenta" v-if="type !== 'PR'">
              <AccountStatusTab />
            </CTab>
            <CTab title="Ventas" v-if="type === 'CL' || type === 'CP'">
              <CustomerSalesTab />
            </CTab>
            <!-- <CTab title="Precios Venta" v-if="type==='CL' || type==='CP'"></CTab> -->
            <!-- <CTab title="Costos Productos" v-if="type==='PR' || type==='CP'"></CTab> -->
            <!-- <CTab title="Entregas Mercancia" v-if="type !== 'PR'"></CTab> -->
            <CTab title="Cotizaciones" v-if="type !=='PR'">
              <QuotesCustomerTab />
            </CTab>
            <CTab title="Pedidos" v-if="type !== 'PR'">
              <OrdersCustomerTab />
            </CTab>
            <!-- <CTab title="Oportunidades" v-if="type !== 'PR'"></CTab> -->
            <CTab title="Seguimientos" v-if="type !== 'PR'">
              <BusinessTrackingTab />
            </CTab>
            <!-- <CTab title="Sucursales"  v-if="type === 'CL' || type === 'CP'"></CTab> -->
            <CTab title="Dependencias">
              <ContactsTab />
            </CTab>
        </CTabs>
    </CCardBody>
  </CCard>
</template>
<script>
  import AccountStatusTab from '@/components/file/DirectoryEmployee/DirectoryEmployeeItemViewTabs/AccountStatusTab.vue'
  import CustomerSalesTab from './DirectoryEmployeeItemViewTabs/CustomerSalesTab.vue'
  import QuotesCustomerTab from "./DirectoryEmployeeItemViewTabs/QuotesCustomerTab.vue";
  import OrdersCustomerTab from "./DirectoryEmployeeItemViewTabs/OrdersCustomerTab.vue";
  import BusinessTrackingTab from "@/components/file/DirectoryEmployee/DirectoryEmployeeItemViewTabs/BusinessTrackingTab.vue";
  import ContactsTab from "../../datagrids/DependenciesDirectory.vue";

  export default {
    data() {
        return {
        }
    },
    components: {
      AccountStatusTab,
      CustomerSalesTab,
      QuotesCustomerTab,
      OrdersCustomerTab,
      BusinessTrackingTab,
      ContactsTab
    },
    methods: {
    },
    computed: {
      selectedDirectory(){
        return this.$store.state.selectedDirectory
      },
      title() {
        if(this.type === 'CL') return 'Cliente'
        if(this.type === 'PR') return 'Proveedor'
        if(this.type === 'CP') return 'Cliente/Proveedor'
        return 'Prospecto'
      },
      type() {
        return this.selectedDirectory.tipo_Directorio
      },
      AccountStatusPath(){
        if(this.type === 'CL') return 'dataGridEstadoCuentaCliente'
        if(this.type === 'PR') return 'dataGridEstadoCuentaProveedor'
        return 'dataGridEstadoCuentaCliente'
      }
    },
    mounted(){
    }
  }
</script>